import { z } from '@/libs/zod';

export const PrizeType = z.enum(['MAIN', 'LUCKY_SEQUENCE', 'GIRO']);
export const LuckySequencyType = z.enum(['LUCKY_WHEEL', 'SCRATCHER', 'SPINNING_TOP']);

export const RaffleStatus = z.enum([
  'PROCESSING_CREATION',
  'NOT_STARTED',
  'IN_PROGRESS',
  'SALES_CLOSED',
  'DRAWING',
  'FINISHED',
  'CANCELED',
  'SOLD_OUT',
  'WAITING_APPROVAL',
]);

export const DrawStatus = z.enum([
  'WINNER_FOUND',
  'WINNER_FOUND_APPROXIMATION',
  'NO_WINNER',
]);

export type PrizeSequenceType = z.infer<typeof LuckySequencyType>;
export type LuckyPrizeType = z.infer<typeof PrizeType>;
